var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "currentColor",
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.777 1.663c-.873.65-1.107 1.677-1.064 2.225.055.669.19 1.54.19 1.54s-.268.146-.268.734c.093 1.474.586.838.688 1.485.244 1.558.801 1.28.801 2.131 0 1.417-.584 2.079-2.408 2.864C1.886 13.431 0 14.422 0 16.141V17h15.463v-.859c0-1.718-1.888-2.71-3.718-3.498-1.824-.785-2.406-1.447-2.406-2.864 0-.85.555-.573.8-2.131.102-.647.595-.01.69-1.486 0-.587-.27-.733-.27-.733s.136-.871.19-1.54a2.654 2.654 0 0 0-1.976-2.66c-.286-.292-.479-.757.4-1.223-1.924-.09-2.371.916-3.396 1.657Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.2195cfb408c5c25203a41a1c6f152018.svg";
export { ForwardRef as ReactComponent };